module.exports = __webpack_public_path__ + "static/img/40001 (1).a14934a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40001 (1).webp
// module id = gWG1
// module chunks = 14